import React from 'react';

import { Typography } from '@mui/material';

import { getCicDisplayValue } from 'utils/cicReason';
import { getConditionalObject } from 'utils/data';

import {
  getCicActionsColumn,
  getCicCommentColumnWidth,
  renderChangeCell,
  renderCommentCell,
  renderEnteredByCell,
} from '../../LoanCicHistory.config';
import { getWrappingCellStyles } from '../../LoanCicHistory.styles';
import { LoanCicHistoryTestIds } from '../../LoanCicHistory.testIds';

import { CicFeeChangeColumnId } from './CicFeeChangesTable.constants';
import { getIsFeeChangeEditable } from './CicFeeChangesTable.utils';

const renderFeeCell = ({ feeName }) => (
  <Typography variant="medium14">{getCicDisplayValue(feeName)}</Typography>
);

const renderReasonCell = ({ id, reasonName }) => (
  <Typography data-testid={LoanCicHistoryTestIds.getFeeChangeReasonId(id)} variant="regular14">
    {getCicDisplayValue(reasonName)}
  </Typography>
);

export const getCicFeeChangesTableConfig = ({ hasActions, isEditAllowed, onEdit }) => ({
  [CicFeeChangeColumnId.FEE]: {
    label: 'Fee',
    width: '15%',
    customStyles: getWrappingCellStyles,
    content: renderFeeCell,
  },
  [CicFeeChangeColumnId.CHANGE]: {
    label: 'Change',
    width: '19%',
    customStyles: getWrappingCellStyles,
    content: renderChangeCell,
  },
  [CicFeeChangeColumnId.REASON]: {
    label: 'Reason',
    width: '22%',
    customStyles: getWrappingCellStyles,
    content: renderReasonCell,
  },
  [CicFeeChangeColumnId.COMMENT]: {
    label: 'Comment',
    width: getCicCommentColumnWidth(hasActions),
    customStyles: getWrappingCellStyles,
    content: renderCommentCell,
  },
  [CicFeeChangeColumnId.ENTERED_BY]: {
    label: 'Entered by',
    width: '18%',
    customStyles: getWrappingCellStyles,
    content: renderEnteredByCell,
  },
  ...getConditionalObject(hasActions, () => ({
    [CicFeeChangeColumnId.ACTIONS]: getCicActionsColumn({
      getIsEditable: feeChange => getIsFeeChangeEditable({ feeChange, isEditAllowed }),
      getDataTestId: LoanCicHistoryTestIds.getFeeChangeEditButtonId,
      onEdit,
    }),
  })),
});
